
//#region Imports
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericMemberResponsePortalResponseDto } from '@app/core/models/genericMembeResponsePortalResponseDto';
import { Observable } from 'rxjs';
import { BaseService } from 'src/app/core/services/base-service.service';
import { EmploymentStatusDto } from '../model/employmentStatusDto';
import { EmploymentStatusResultDto } from '../model/employmentStatusResultDto';

//#endregion Imports

@Injectable({
  providedIn: 'root'
})

export class EmploymentStatusService extends BaseService {

    //#region Constructor
    constructor(http: HttpClient) {
        super(http);
    }
     //#endregion Constructor

    //#region Public Methods
    public Save(employmentStatusRequestDto: EmploymentStatusDto): Observable<GenericMemberResponsePortalResponseDto<EmploymentStatusResultDto>>{
        return this.Post('/Survey/EmploymentStatus', employmentStatusRequestDto);
    }
    //#endregion Public Methods
}
